import { useMemo } from 'react';

import { useAppSelector } from 'hooks';
import { selectFiles, selectTimeCodes } from 'state';
import { convertTimeToNumber, getFileStartAndEndTime } from 'utils';

export const useTimecodes = () => {
  const files = useAppSelector(selectFiles);
  const tc = useAppSelector(selectTimeCodes);

  const timecodes = useMemo(
    () =>
      tc.map(timecode => {
        const { fileStartTime } = getFileStartAndEndTime(files, timecode.fileId);

        return {
          ...timecode,
          inspectionTimecodeStart: Math.round(
            convertTimeToNumber(timecode.timecodeStart) + fileStartTime,
          ),
          inspectionTimecodeEnd: Math.round(
            convertTimeToNumber(timecode.timecodeEnd) + fileStartTime,
          ),
          inspectionTimecodeClosest: Math.round(
            convertTimeToNumber(timecode.timecodeClosest) + fileStartTime,
          ),
        };
      }),
    [tc],
  );

  const inspectionDuration = useMemo(
    () => files.reduce((total, file) => (file.fileLengthSeconds || 0) + total, 0),
    [files],
  );

  return { inspectionDuration, timecodes };
};
